import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/Footer.scss';

export default function Footer({
    className,
    ...props
}) {
    const classes = classNames(styles.footer, className);
    return (
        <div {...props} className={classes}>
            <img src='../../../../img/logo/takeback.svg' role='presentation'className={styles.brand} />
            <ul className={styles.menu}>
                <li className={styles.menuItem}>
                    <a href='/classic/support' className={styles.menuLink}>
                        <FormattedMessage id='navigation.link.support' />
                    </a>
                </li>
                <li className={styles.menuItem}>
                    <a href='/imprint' className={styles.menuLink}>
                        <FormattedMessage id='navigation.link.imprint' />
                    </a>
                </li>
                <li className={styles.menuItem}>
                    <a href='/privacy-protection' className={styles.menuLink}>
                        <FormattedMessage id='navigation.link.privacy-protection' />
                    </a>
                </li>
                <li className={styles.menuItem}>
                    <a href='/terms' className={styles.menuLink}>
                        <FormattedMessage id='navigation.link.terms' />
                    </a>
                </li>
            </ul>
        </div>
    );
}

Footer.propTypes = {
    className: PropTypes.string,
};
